define(['knockout', 'underscore', 'postal', 'globals'], function (ko, _, postal, globals) {
    function VisualizerViewModel(productId, orderedOptions) {

        var self = this;
        self._queryStringOptions = "?fmt=jpeg&fit=constrain,1&wid=176&hei=300";
        self._zoomedQueryStringOptions = "?fmt=jpeg&fit=constrain,1&wid=600&hei=800";
        self._pipPostalChannel = postal.channel('productpage');
        self._pcpPostalChannel = postal.channel('ProductConfigurator');

        self.productId = productId; //Never changes
        self.anyVisualizableOptions = ko.observable(orderedOptions != null && orderedOptions.length > 0);
        self.shouldShowVisualizer = ko.observable(orderedOptions != null && orderedOptions.length > 0);

        self.selectedChoices = ko.observableArray();
        self.visualizerURL = ko.observable();
        self.visualizerZoomedURL = ko.observable();
        self.ioshack = globals.isIOS;

        self.visualizedOptionList = _.sortBy(orderedOptions, function (item) {
            return item.order;
        });

        self.isOptionVisualizable = function (optionId) {
            var foundOption =  _.findWhere(self.visualizedOptionList, { OptionId: optionId });
            if (foundOption === undefined) {
                return false;
            }
            return true;
        };

        self.setupSubscriptions = function () {
            //PRODUCT PAGE SUBSCRIPTION
            self._pipPostalChannel.subscribe("selection.changed", function (choice) {
              if (typeof choice.selected === 'function') {
                //This comes from selection/deselection of a choice by the user
                if (!choice.selected()) {
                  self.setChoiceById(choice.optionId, choice.choiceid);
                } else {
                  self.deselectChoiceById(choice.optionId);
                }
              } else {
                ///This comes from page load -- the use choice.id instead of choiceId
                self.setChoiceById(choice.optionId, choice.id);
              }
            });

            self.clearAllDependents = function (option) {
                var dependents = option.getDependents();
                _.each(dependents, function (dep) {
                    var existing = self.findSelectedChoice(dep.id());
                    self.selectedChoices.remove(existing);
                })
            }
            //CONFIGURATOR PAGE SUBSCRIPTION
            self._pcpPostalChannel.subscribe("option-changed", function (data) {
              if (data !== undefined && data.option !== undefined && data.isEnabled !== undefined) {
                  self.clearAllDependents(data.option);
                  var selections = data.option.getSelections();
                  const selected = (data.currentChoice && data.currentChoice.selected()) || data.isSelected;

                  if (selected && data.isEnabled) {
                  _.each(selections, function (selection) {
                      if (self.isOptionVisualizable(selection.id()) && selection.selectedChoice()) {
                          self.setChoice(selection, selection.selectedChoice().id());
                      }
                  });
                } else {
                  _.each(selections, function (selection) {
                      if (self.isOptionVisualizable(selection.id() && selection.selectedChoice())) {
                          self.deselectChoice(selection, selection.selectedChoice().id());
                      }
                  });
                }
              }
            });
            self._pcpPostalChannel.subscribe("option-disabled", function (data) {
              if (data !== undefined && data.option !== undefined && data.isEnabled !== undefined) {
                self.deselectChoice(data.option);
              }
            });
            self._pcpPostalChannel.subscribe("option-enabled", function (data) {
              if (data !== undefined && data.option !== undefined && data.isEnabled !== undefined) {
                  self.setChoice(data.option, data.currentChoice);
              }
            });
        };


        self.findSelectedChoice = function (optionId) {
            return _.find(self.selectedChoices(), function (selection) {
                return selection.optionId === optionId;
            });
        };

        self.updateUrl = function () {
          if (self.selectedChoices().length === 0) {
            //No choices means show a blank
            self.visualizerURL("/Content/Images/visualizer-blank.png");
            self.visualizerZoomedURL(undefined);
          } else {
            var url = _.reduce(self.visualizedOptionList, function(memo, option) {
              var matchingChoice = self.findSelectedChoice(option.OptionId);
              if (matchingChoice) {
                return memo + '_' + matchingChoice.choiceId;
              }
              return memo;
            }, self.productId);
            self.visualizerURL(globals.visualizationBaseUrl + url + self._queryStringOptions);
            self.visualizerZoomedURL(globals.visualizationBaseUrl + url + self._zoomedQueryStringOptions);
          }
        };

        //Method used to set the individual choices -- may need to subscribe
        //  to postal in the end

        self.setChoiceById = function (optionId, choiceId) {
            var existing = self.findSelectedChoice(optionId);
            self.selectedChoices.remove(existing);
            self.selectedChoices.push({ 'optionId': optionId, 'choiceId': choiceId });

            self.updateUrl();
        };
        self.setChoice = function (option, choiceId) {
            var existing = self.findSelectedChoice(option.id());
            if (existing) {
                var existingDependentOptions = existing.choice.options();
                var existingDependentSelections = [];
                _.each(existingDependentOptions, function (dep) {
                    _.each(dep.getDependents(), function (depSelect) {
                        existingDependentSelections.push(depSelect);
                    });
                });
                _.each(existingDependentSelections, function (selection) {
                    if (self.isOptionVisualizable(selection.id())) {
                        self.deselectChoice(selection);
                    }
                });
                self.selectedChoices.remove(existing);
            }

          self.selectedChoices.push({'optionId': option.id(), 'choiceId': choiceId, 'choice': option.selectedChoice()});

          self.updateUrl();
        };
        self.deselectChoiceById = function (optionId) {
            var existing = self.findSelectedChoice(optionId);
            self.selectedChoices.remove(existing);
            self.updateUrl();
        }
        self.deselectChoice = function(option) {
          var existing = self.findSelectedChoice(option.id());
          self.selectedChoices.remove(existing);
          self.updateUrl();
        };

      self.setupSubscriptions();
    }

    return VisualizerViewModel;
});

